export function throttle<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let lastFunc: ReturnType<typeof setTimeout> | undefined;
  let lastRan: number | undefined;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (lastRan === undefined) {
      func.apply(this, args);
      lastRan = Date.now();
    } else {
      if (lastFunc !== undefined) {
        clearTimeout(lastFunc);
      }
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan! >= delay) {
            func.apply(this, args);
            lastRan = Date.now();
          }
        },
        delay - (Date.now() - lastRan)
      );
    }
  } as (...args: Parameters<T>) => void;
}
